import { Linkable } from '@/components/blocks/Linkable';
import { Stack, SxProps, Typography } from '@mui/material';
import { titleSX, linkSX } from '@/components/blocks/GroupPageLink/styles';
import { combineSX } from '@/utils/combineSX';

export const DpFooterGroupLinkFrame: React.FC<{
	title: string;
	children: React.ReactNode;
}> = ({ title, children }) => (
	<Stack spacing={1}>
		<Typography sx={titleSX}>{title}</Typography>
		<ul style={{ padding: 0, listStyleType: 'none' }}>{children}</ul>
	</Stack>
);

export const DpFooterGroupLink: React.FC<{
	id?: string;
	href?: string;
	islast?: boolean;
	sx?: SxProps;
	target?: string;
	children: React.ReactNode;
}> = ({ id, href, islast = false, sx, target, children }) => (
	<li
		style={{
			marginBottom: islast ? 0 : 'var(--spacing-1)',
		}}
	>
		<Linkable data-testid={id} id={id} href={href} sx={combineSX([linkSX, sx])} target={target}>
			{children}
		</Linkable>
	</li>
);
